
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g3qL5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8zMP3 = parcelRequire("8zMP3");


var $8Hqv7 = parcelRequire("8Hqv7");


var $2VZOl = parcelRequire("2VZOl");


var $98zed = parcelRequire("98zed");


var $1NBp8 = parcelRequire("1NBp8");


var $kE2cJ = parcelRequire("kE2cJ");


var $6mKj3 = parcelRequire("6mKj3");


var $6gETM = parcelRequire("6gETM");


var $8jRXE = parcelRequire("8jRXE");

const $f9df14c16cd36eb8$export$99fa8db8497fb663 = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType })=>{
    const livePageSSRStatus = (0, $98zed.useIsLivePageWithSSR)();
    if (livePageSSRStatus.isTypeKnown && livePageSSRStatus.isLive) // Remove draftShareId if it exists, to avoid persisting it on live doc. If the param exists on live doc, it prevents SSR from preloading live doc title/content
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.VIEW_PAGE).name,
        params: {
            contentId: contentId,
            spaceKey: spaceKey
        },
        excludedQueryParams: [
            'draftShareId'
        ]
    });
    return (0, $6mKj3.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "content-main"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8jRXE.FullPageEditorLoader), {
        // Matching the logic in NativeCollabComponent
        // confluence/next/packages/native-collab/src/NativeCollabComponent.tsx#getDraftMeta
        isUnpublishedDraft: !!draftShareId,
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        collabEditState: {},
        heartbeatData: {},
        disabled: true
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Hqv7.FullCycleRenderWithProfiler), {
        name: "edit-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8jRXE.FullPageEditorLoader), {
        // Matching the logic in NativeCollabComponent
        // confluence/next/packages/native-collab/src/NativeCollabComponent.tsx#getDraftMeta
        isUnpublishedDraft: !!draftShareId,
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        collabEditState: {},
        heartbeatData: {},
        disabled: true
    }))));
};
module.exports["EditPageLoaderServer"] = $f9df14c16cd36eb8$export$99fa8db8497fb663;

});

parcelRegister("98zed", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");


var $eNbbn = parcelRequire("eNbbn");

const $91141199ce9a5735$export$899773b8bcad4fc7 = ()=>{
    const isTransition = (0, $dPJCf.useIsTransition)();
    const ssrStatus = (0, $eNbbn.useLivePageSSRStatus)();
    if (!ssrStatus.isTypeKnown && isTransition) return {
        isLive: undefined,
        isTypeKnown: false
    };
    return ssrStatus;
};
module.exports["useIsLivePageWithSSR"] = $91141199ce9a5735$export$899773b8bcad4fc7;

});


//# sourceMappingURL=EditPageLoaderServer.37665df5.js.map
